import { VendorsAction, VendorsState } from "../../../../types/vendors.types";

const initialState: VendorsState = {
  hasFetched: false,
  data: {},
  fetchError: null,
  isFetching: false,
};

export default function vendors(
  state = initialState,
  action: VendorsAction,
): VendorsState {
  if ("VENDORS_FETCH_REQUEST" === action.type) {
    return { ...state, isFetching: true };
  }

  if ("VENDORS_FETCH_SUCCESS" === action.type) {
    return { ...state, data: action.data, hasFetched: true, isFetching: false };
  }

  if ("VENDORS_FETCH_FAILURE" === action.type) {
    return {
      ...state,
      fetchError: action.fetchError,
      hasFetched: true,
      isFetching: false,
    };
  }

  return state;
}
